var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSince(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.347,
    height: 12.846,
    viewBox: "0 0 13.347 12.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M139.21,157h13.347v12.846H139.21Z",
    fill: "#ff7200"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "since",
    transform: "translate(-139.21 -157)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M152.049,158.457h-1.54v-.513a.513.513,0,1,0-1.027,0v.513h-.513v-.513a.513.513,0,1,0-1.027,0v.513h-4.107v-.513a.513.513,0,0,0-1.027,0v.513H142.3v-.513a.513.513,0,1,0-1.027,0v.513h-1.54a.514.514,0,0,0-.513.513v10.781a.514.514,0,0,0,.513.513h12.321a.514.514,0,0,0,.513-.513V158.97A.514.514,0,0,0,152.049,158.457Zm-6.674,4.107v1.54h-2.053v-1.54Zm3.08,0v1.54H146.4v-1.54Zm3.08,0v1.54h-2.053v-1.54Zm-9.24,1.54h-2.053v-1.54H142.3Zm-2.053,1.027H142.3v1.54h-2.053Zm3.08,0h2.053v1.54h-2.053Zm2.053,2.567v1.54h-2.053V167.7Zm1.027,0h2.053v1.54H146.4Zm0-1.027v-1.54h2.053v1.54Zm3.08-1.54h2.053v1.54h-2.053Zm-8.214-5.647V160a.513.513,0,0,0,1.027,0v-.513h.513V160a.513.513,0,0,0,1.027,0v-.513h4.107V160a.513.513,0,0,0,1.027,0v-.513h.513V160a.513.513,0,1,0,1.027,0v-.513h1.027v2.053H140.242v-2.053Zm-1.027,8.214H142.3v1.54h-2.053Zm9.24,1.54V167.7h2.053v1.54Z",
    transform: "translate(-0.005 -0.418)",
    fill: "#ff7200"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSince);
export default __webpack_public_path__ + "static/media/since.f22bfc7db68dfaec5a5897194d927de8.svg";
export { ForwardRef as ReactComponent };